<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay>
        <v-card >
            <div class="pa-3">
                <v-img src="https://www.dikitoon.com/img/DikitoonBetaSvgLogo.cbb7fd28.svg" max-width="160"></v-img>
                <h2>{{shopName}}は、Dikitoon.comへの掲載を終了しました。</h2>

                <p>これまでご利用いただきありがとうございました。</p>
            </div>

        </v-card>
    </v-dialog>
</template>

<script>
//import { AmplifyEventBus } from 'aws-amplify-vue'
//import moment from 'moment-timezone'
import { Logger } from 'aws-amplify';
const logger = new Logger('PermanentlyClosedFullComponent','INFO');

export default {
    data() {
        return {
            dialog: true
        }
    },
    async mounted(){
        logger.info("SuspendedFullComponent",this.resumeOnStr)
    },
    computed:{
        shopName:function(){
            return this.$store.state.shopName
        },

    }
}
</script>